import { createContext } from "react";

const TransactionsContext = createContext();

export default TransactionsContext;
